(function () {
  'use strict';

  var root = document.querySelector('[data-awakening]');
  if (!root) return;
  if (window.BBJT_AWAKENING_READY) return;

  window.BBJT_AWAKENING_READY = true;

  var config = window.BBJT_AWAKENING_CONFIG || {};
  var events = config.events || {};
  var body = document.body;
  var beginButton = root.querySelector('[data-awakening-begin]');
  var replayButton = root.querySelector('[data-awakening-replay]');
  var skipButton = root.querySelector('[data-awakening-skip]');
  var liveRegion = root.querySelector('[data-awakening-live]');
  var audio = root.querySelector('[data-awakening-audio]');
  var storageKey = config.storageKey || 'bbjt-awakening-complete';
  var timers = [];
  var reducedMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reducedMotion = reducedMotionQuery ? reducedMotionQuery.matches : false;
  var media = createMediaController(root, config, reducedMotion);
  var beginEventLocked = false;
  var debugEnabled = false;

  try {
    debugEnabled = Boolean(
      (window.Shopify && window.Shopify.designMode) ||
      window.location.search.indexOf('bbjt_debug=1') !== -1
    );
  } catch (error) {
    debugEnabled = false;
  }

  function debugLog(message, detail) {
    if (!debugEnabled || !window.console || !window.console.log) return;
    if (typeof detail === 'undefined') {
      window.console.log('[BBJT Threshold]', message);
    } else {
      window.console.log('[BBJT Threshold]', message, detail);
    }
  }

  function readMediaConfig() {
    var node = root.querySelector('[data-awakening-media-config]');
    if (!node) return {};

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  }

  function dispatchEvent(name, detail) {
    if (!name) return;

    var event;
    if (typeof window.CustomEvent === 'function') {
      event = new window.CustomEvent(name, {
        bubbles: true,
        detail: detail
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, true, false, detail);
    }

    root.dispatchEvent(event);
  }

  function announce(message) {
    if (liveRegion && message) liveRegion.textContent = message;
  }

  function getTimeline() {
    var timelineConfig = config.timeline || {};
    var selected = reducedMotion ? timelineConfig.reduced : timelineConfig.full;
    if (!selected || !selected.length) selected = timelineConfig.full || [];

    return selected.slice().sort(function (first, second) {
      return first.at - second.at;
    });
  }

  function setState(state, frame, truthStep) {
    if (state) root.setAttribute('data-state', state);

    if (truthStep) {
      root.setAttribute('data-truth-step', truthStep);
    } else {
      root.removeAttribute('data-truth-step');
    }

    if (typeof frame !== 'undefined') media.showFrame(frame);
  }

  function applyCue(cue) {
    if (cue.name === 'handEntrance') media.revealProduction();
    if (cue.name === 'navigationUnlock') body.classList.add('awakening-navigation-visible');
    root.setAttribute('data-cue', cue.name || '');
    root.setAttribute('data-effect', reducedMotion ? 'still' : cue.effect || 'idle');

    setState(cue.state, cue.frame, cue.truthStep);
    announce(cue.announce);
    debugLog('sequence state changed', {
      cue: cue.name,
      state: cue.state,
      frame: cue.frame,
      effect: reducedMotion ? 'still' : cue.effect || 'idle'
    });

    dispatchEvent(events.cue, {
      cue: cue.name,
      at: cue.at,
      state: cue.state,
      frame: cue.frame,
      effect: reducedMotion ? 'still' : cue.effect || 'idle',
      reducedMotion: reducedMotion
    });

    if (cue.audioHook) {
      dispatchEvent(events.audioCue, {
        hook: cue.audioHook,
        cue: cue.name,
        at: cue.at,
        audioOptional: true
      });
    }

  }

  function clearTimers() {
    timers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    timers = [];
  }

  function startAudio() {
    if (!audio || !audio.getAttribute('src')) {
      root.setAttribute('data-audio-state', 'unavailable');
      return;
    }
    if (!audio.paused) return;
    var attempt = audio.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        root.setAttribute('data-audio-state', 'unavailable');
      });
    }
    root.setAttribute('data-audio-state', 'playing');
  }

  function scheduleTimeline() {
    getTimeline().forEach(function (cue) {
      timers.push(window.setTimeout(function () {
        applyCue(cue);
      }, cue.at));
    });
  }

  function completeIntro() {
    if (!audio || audio.ended !== true) return;
    clearTimers();
    setState('navigation', 'logo');
    root.setAttribute('data-cue', 'introComplete');
    root.setAttribute('data-effect', 'settled');
    body.classList.remove('awakening-pending', 'awakening-running');
    body.classList.add('awakening-navigation-visible', 'awakening-complete');
    media.teardown();

    try {
      window.sessionStorage.setItem(storageKey, 'true');
    } catch (error) {
      // Session storage may be blocked; the intro still works without it.
    }

    announce('Beats By JT revealed. Navigation is now available.');
    dispatchEvent(events.complete, {
      skipped: false,
      reducedMotion: reducedMotion
    });

    var navTarget = document.querySelector('[data-awakening-nav] a');
    if (navTarget) {
      try {
        navTarget.focus({ preventScroll: true });
      } catch (error) {
        navTarget.focus();
      }
    }
  }

  function startIntro() {
    debugLog('controller start called');
    clearTimers();
    root.removeAttribute('data-returning');
    root.removeAttribute('data-truth-step');
    body.classList.remove('awakening-pending', 'awakening-complete', 'awakening-js-failed');
    body.classList.remove('awakening-navigation-visible');
    body.classList.add('awakening-running');
    setState('commit', 'black');
    root.setAttribute('data-cue', 'black');
    root.setAttribute('data-effect', reducedMotion ? 'still' : 'black');
    startAudio();
    media.prepare();
    media.play();
    media.revealProduction();
    scheduleTimeline();
  }

  function revealReturningSession() {
    setState('navigation', 'logo');
    root.setAttribute('data-cue', 'returningSession');
    root.setAttribute('data-effect', 'settled');
    body.classList.remove('awakening-pending', 'awakening-running');
    body.classList.add('awakening-navigation-visible', 'awakening-complete');
    media.teardown();
  }

  function hasCompletedSession() {
    try {
      return window.sessionStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function updateBeginLabel(label) {
    if (!beginButton) return;

    if (beginButton.hasAttribute('data-awakening-pad-entry')) {
      var accessibleLabel = beginButton.getAttribute('aria-label') || 'Enter the Beats By JT experience';
      var labelNode = beginButton.querySelector('[data-awakening-entry-label]');

      beginButton.setAttribute('aria-label', accessibleLabel);
      if (labelNode) labelNode.textContent = accessibleLabel;
      return;
    }

    beginButton.textContent = label;
  }

  function markReturningVisitor() {
    if (!hasCompletedSession()) return;

    root.setAttribute('data-returning', 'true');
    updateBeginLabel(root.getAttribute('data-returning-label') || 'CONTINUE');
  }

  function handleBegin() {
    if (root.getAttribute('data-returning') === 'true') {
      revealReturningSession();
      return;
    }

    startIntro();
  }

  function beginFromInteraction(event, source) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    debugLog('activation received', source || 'unknown');

    if (beginEventLocked || body.classList.contains('awakening-running')) return;
    beginEventLocked = true;
    handleBegin();

    window.setTimeout(function () {
      beginEventLocked = false;
    }, 500);
  }

  function setPadIntent(active, source) {
    if (!beginButton) return;

    beginButton.classList.toggle('is-pad-intent', active);
    if (active) debugLog('hover/focus activation', source || 'unknown');
  }

  function setPadPressed(active) {
    if (!beginButton) return;

    beginButton.classList.toggle('is-pad-pressed', active);
  }

  function createMediaController(scope, runtimeConfig, prefersReducedMotion) {
    var mediaConfig = readMediaConfig();
    var container = scope.querySelector('[data-awakening-media]');
    var video = scope.querySelector('[data-awakening-video]');
    var poster = scope.querySelector('[data-awakening-poster]');
    var frameNodes = Array.prototype.slice.call(scope.querySelectorAll('[data-awakening-frame]'));
    var frameMap = {};
    var mobileMediaQuery = runtimeConfig.mobileMediaQuery || '(max-width: 767px)';
    var mobileQuery = window.matchMedia ? window.matchMedia(mobileMediaQuery) : null;
    var prepared = false;
    var productionRevealed = false;
    var videoReady = false;
    var posterReady = false;
    var productionPlaybackStarted = false;

    frameNodes.forEach(function (frame) {
      frameMap[frame.getAttribute('data-awakening-frame')] = frame;
    });

    function frameSource(name) {
      var frames = mediaConfig.frames || {};
      return frames[name] && frames[name].src ? frames[name].src : '';
    }

    function ensureFrame(name) {
      var frame = frameMap[name];
      if (!frame || frame.tagName !== 'IMG') return;

      var src = frameSource(name) || frame.getAttribute('data-src');
      if (src && frame.getAttribute('src') !== src) frame.setAttribute('src', src);
      frame.removeAttribute('data-src');
    }

    function loadSequenceFrames() {
      frameNodes.forEach(function (frame) {
        ensureFrame(frame.getAttribute('data-awakening-frame'));
      });
    }

    function selectedVideoUrl() {
      var videoConfig = mediaConfig.video || {};
      if (prefersReducedMotion) return '';
      if (mobileQuery && mobileQuery.matches && videoConfig.mobile) return videoConfig.mobile;
      return videoConfig.desktop || videoConfig.mobile || '';
    }

    function showVideo() {
      if (!container) return;
      if (!productionRevealed) return;
      container.classList.add('is-video-active');
      container.classList.remove('is-poster-active');
      scope.setAttribute('data-media-mode', 'video');
    }

    function startProductionPlayback() {
      if (!video || !videoReady || !productionRevealed) return;

      if (productionPlaybackStarted) return;
      productionPlaybackStarted = true;

      var startAt = runtimeConfig.videoStartSeconds || 0;
      if (startAt > 0) {
        try { video.currentTime = startAt; } catch (error) {}
      }

      video.setAttribute('autoplay', '');
      video.autoplay = true;
      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(deactivateVideo);
      }
    }

    function markVideoReady() {
      videoReady = true;
      if (productionRevealed) {
        startProductionPlayback();
      }
    }

    function activatePoster() {
      if (!container || !posterReady || videoReady || !productionRevealed) return;
      container.classList.add('is-poster-active');
      container.classList.remove('is-video-active');
      scope.setAttribute('data-media-mode', 'poster');
    }

    function deactivateVideo() {
      if (!container) return;
      container.classList.remove('is-video-active');
      videoReady = false;
      if (posterReady) {
        activatePoster();
      } else {
        container.classList.remove('is-poster-active');
        scope.setAttribute('data-media-mode', 'stills');
      }
    }

    function holdLastFrame() {
      if (!video || !container) return;
      // The non-looping video element naturally retains its decoded final frame.
      // Keep the media layer visible while the title cards and Sonic Identity finish.
      container.classList.add('is-video-held');
      scope.setAttribute('data-video-state', 'held');
      showVideo();
    }

    function preparePoster() {
      var posterConfig = (mediaConfig.video || {}).poster;
      if (!poster || !posterConfig) return;

      poster.addEventListener('load', function () {
        posterReady = true;
        activatePoster();
      }, { once: true });
      poster.addEventListener('error', function () {
        posterReady = false;
        if (!videoReady) scope.setAttribute('data-media-mode', 'stills');
      }, { once: true });
      poster.setAttribute('src', posterConfig);
      poster.removeAttribute('data-src');
    }

    function prepareVideo() {
      var src = selectedVideoUrl();
      if (!video || !src) {
        deactivateVideo();
        return;
      }

      video.addEventListener('canplay', markVideoReady, { once: true });
      video.addEventListener('playing', showVideo, { once: true });
      video.addEventListener('ended', holdLastFrame, { once: true });
      video.addEventListener('error', deactivateVideo, { once: true });

      if (video.getAttribute('src') !== src) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.preload = 'metadata';
        video.setAttribute('src', src);
        video.load();
      }
    }

    function teardownPlayback() {
      productionRevealed = false;
      productionPlaybackStarted = false;
      videoReady = false;

      if (video) {
        try {
          if (!video.paused) video.pause();
        } catch (error) {}
        video.removeAttribute('src');
        video.preload = 'none';
        video.removeAttribute('autoplay');
        if (container) {
          container.classList.remove('is-video-active', 'is-video-held');
        }
        scope.removeAttribute('data-video-state');
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(function () {
            try { video.load(); } catch (error) {}
          }, { timeout: 2000 });
        }
      }

      if (poster && posterReady && container) {
        container.classList.add('is-poster-active');
        scope.setAttribute('data-media-mode', 'poster');
      }
    }

    return {
      prepare: function () {
        if (!prepared) {
          prepared = true;
          preparePoster();
        }
        prepareVideo();
      },
      play: function () {
        if (!video || !video.getAttribute('src') || prefersReducedMotion) return;
        productionRevealed = false;
        productionPlaybackStarted = false;
        container.classList.remove('is-video-held');
        scope.removeAttribute('data-video-state');
        try {
          video.currentTime = 0;
        } catch (error) {}
        // The muted autoplay element is prepared from the activation gesture,
        // but visible playback is gated to the locked 1.20-second cue.
      },
      revealProduction: function () {
        productionRevealed = true;
        if (videoReady) {
          startProductionPlayback();
        }
      },
      showFrame: function (name) {
        ensureFrame(name);
        frameNodes.forEach(function (frame) {
          frame.classList.toggle('is-active', frame.getAttribute('data-awakening-frame') === name);
        });
      },
      hold: function () {},
      teardown: teardownPlayback
    };
  }

  debugLog(beginButton ? 'button found' : 'button missing');

  if (beginButton) {
    beginButton.addEventListener('pointerenter', function () {
      setPadIntent(true, 'pointerenter');
    });
    beginButton.addEventListener('pointerleave', function () {
      setPadIntent(false, 'pointerleave');
      setPadPressed(false);
    });
    beginButton.addEventListener('mouseover', function () {
      setPadIntent(true, 'mouseover');
    });
    beginButton.addEventListener('mouseleave', function () {
      setPadIntent(false, 'mouseleave');
      setPadPressed(false);
    });
    beginButton.addEventListener('focus', function () {
      setPadIntent(true, 'focus');
    });
    beginButton.addEventListener('blur', function () {
      setPadIntent(false, 'blur');
      setPadPressed(false);
    });
    beginButton.addEventListener('pointerdown', function () {
      setPadPressed(true);
    });
    beginButton.addEventListener('pointercancel', function () {
      setPadPressed(false);
    });
    beginButton.addEventListener('pointerup', function (event) {
      setPadPressed(false);
      beginFromInteraction(event, 'pointerup');
    });
    beginButton.addEventListener('touchend', function (event) {
      setPadPressed(false);
      beginFromInteraction(event, 'touchend');
    }, { passive: false });
    beginButton.addEventListener('click', function (event) {
      beginFromInteraction(event, 'click');
    });
    beginButton.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        beginFromInteraction(event, 'keyboard');
      }
    });

    debugLog('listener attached');
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('[data-awakening-pad-entry]') : null;
    if (target && root.contains(target) && target === beginButton) {
      debugLog('fallback start called', 'delegated click');
      beginFromInteraction(event, 'delegated click');
    }
  }, true);

  if (replayButton) {
    replayButton.addEventListener('click', startIntro);
  }

  if (audio) {
    audio.addEventListener('ended', function () {
      root.setAttribute('data-audio-state', 'complete');
      if (body.classList.contains('awakening-running')) completeIntro();
    });
    audio.addEventListener('error', function () {
      root.setAttribute('data-audio-state', 'unavailable');
    });
  }

  function getRestoredScrollPosition() {
    var scrollingElement = document.scrollingElement ||
      document.documentElement ||
      document.body;

    return Math.max(
      window.scrollY || 0,
      window.pageYOffset || 0,
      scrollingElement ? scrollingElement.scrollTop || 0 : 0
    );
  }

  function releaseRestoredMidPageAwakeningLock() {
    var hasAwakeningLock =
      body.classList.contains('awakening-pending') ||
      body.classList.contains('awakening-running');

    if (!hasAwakeningLock) return;

    if (getRestoredScrollPosition() <= 1) return;

    revealReturningSession();
  }

  function scheduleRestoredMidPageUnlock() {
    releaseRestoredMidPageAwakeningLock();

    window.requestAnimationFrame(function () {
      releaseRestoredMidPageAwakeningLock();

      window.requestAnimationFrame(function () {
        releaseRestoredMidPageAwakeningLock();
      });
    });
  }

  markReturningVisitor();
  scheduleRestoredMidPageUnlock();

  window.addEventListener('pagehide', function () {
    clearTimers();
  });

  window.addEventListener('pageshow', function () {
    scheduleRestoredMidPageUnlock();
  });
})();
